import {View} from 'native-base';
import React from 'react';
import Icon from 'react-native-vector-icons/FontAwesome5Pro';

interface OcrmRewardListItemCheckProps {
  size: number;
  color: string;
}
const OcrmRewardListItemCheck = ({
  size,
  color,
}: OcrmRewardListItemCheckProps) => (
  <View
    backgroundColor="white"
    position="absolute"
    top={(-1 * size) / 2}
    left={(-1 * size) / 2}>
    <Icon name="check-circle" solid color={color} size={size} />
  </View>
);

export default OcrmRewardListItemCheck;
